"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var React = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _ThemeProvider = require("../../theme/ThemeProvider");

var _withLabel = _interopRequireDefault(require("../../hoc/withLabel"));

var _Input = _interopRequireDefault(require("../../component/Input"));

// TODO
var Wrapped = (0, _withLabel["default"])(_Input["default"]);
var useStyles = (0, _ThemeProvider.createUseStyles)({
  InputWithLabel: {
    '&, &[type], &[type][readonly]': {
      marginLeft: 5
    }
  }
});

var InputWithLabel = function InputWithLabel(_ref) {
  var wrappedClassName = _ref.wrappedClassName,
      rest = (0, _objectWithoutProperties2["default"])(_ref, ["wrappedClassName"]);
  var classes = useStyles();
  return /*#__PURE__*/React.createElement(Wrapped, (0, _extends2["default"])({}, rest, {
    position: "right",
    wrappedClassName: (0, _classnames["default"])(classes.InputWithLabel, wrappedClassName)
  }));
};

var _default = InputWithLabel;
exports["default"] = _default;
//# sourceMappingURL=InputWithLabel.js.map